import { render, staticRenderFns } from "./Fascism.vue?vue&type=template&id=fea347ca&scoped=true&"
import script from "./Fascism.vue?vue&type=script&lang=js&"
export * from "./Fascism.vue?vue&type=script&lang=js&"
import style0 from "./Fascism.vue?vue&type=style&index=0&id=fea347ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea347ca",
  null
  
)

export default component.exports